<template>
	<button
		:class="{ active: selected }"
		class="filter-button"
		@click="handleClick"
		:aria-label="ariaLabel"
	>
		{{ name }}
	</button>
</template>

<script>
export default {
	name: 'FilterButton',
	props: {
		name: String,
		ariaLabel: {
			type: String,
			default: 'Filter button',
		},
		selected: {
			type: Boolean,
			default: false,
		},
	},
	methods: {
		handleClick() {
			this.$emit('onClick');
		},
	},
};
</script>

<style lang="scss" scoped>
.filter-button {
	width: fit-content;
	min-height: 32px;
	background-color: $white;
	border-radius: 6px;
	border: 1px solid $border-color-light;
	@include rem('font-size', 16px);

	&:hover,
	&:active,
	&.active {
		background-color: $highlight-color;
		border: 1px solid $brand-blue;
		cursor: pointer;
		outline: none;
	}
}
</style>
